function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.313 18.844H4.688a.183.183 0 00-.188.178v1.425c0 .098.084.178.188.178h14.625c.103 0 .187-.08.187-.178v-1.425a.183.183 0 00-.188-.178zM12 17.062a6.059 6.059 0 004.308-1.785 6.045 6.045 0 001.786-4.308V3.656a.282.282 0 00-.282-.281h-1.406a.282.282 0 00-.281.281v7.313A4.131 4.131 0 0112 15.094a4.131 4.131 0 01-4.125-4.125V3.656a.282.282 0 00-.281-.281H6.187a.282.282 0 00-.28.281v7.313a6.06 6.06 0 001.785 4.308A6.045 6.045 0 0012 17.063z"
})));